var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93905 11.0911C10.2483 11.4004 10.7612 11.4004 11.0704 11.0911C11.3797 10.7819 11.3797 10.269 11.0704 9.95976L7.11066 6L11.0704 2.04024C11.3797 1.731 11.3797 1.21811 11.0704 0.90887C10.7612 0.599629 10.2483 0.599629 9.93905 0.90887L5.97929 4.86863L2.01945 0.908793C1.71021 0.599552 1.19733 0.599553 0.888084 0.908794C0.578843 1.21804 0.578842 1.73092 0.888083 2.04016L4.84792 6L0.888083 9.95983C0.578842 10.2691 0.578842 10.782 0.888083 11.0912C1.19732 11.4004 1.71021 11.4004 2.01945 11.0912L5.97929 7.13137L9.93905 11.0911Z",
    fill: "#E4291D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTick);
export default __webpack_public_path__ + "static/media/red-tick.4e93930c4a7a068e1a87e3ebc187c24a.svg";
export { ForwardRef as ReactComponent };